export default __webpack_public_path__ + "static/media/Boost_Logo_Loading_67x67.b27fbc22.gif";